import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAction } from "../types/Action/IAction";

export type SelectedAction = {
    actionId: number;
    ticketId: number;
}

const SelectedActionSlice = createSlice({
    name: "SelectedActionSlice",
    initialState: {
        selectedActions: null as SelectedAction[],
        currentPageActionIds: [] as number[]
    },
    reducers: {
        SetSelectedActions: (state, action: PayloadAction<SelectedAction[]>) => {
            state.selectedActions = action.payload;
        },
        SetCurrentPageActions: (state, action: PayloadAction<number[]>) => {
            state.currentPageActionIds = action.payload;
        }
    }
});

export const { SetSelectedActions, SetCurrentPageActions } = SelectedActionSlice.actions
export default SelectedActionSlice.reducer